import type { ViewTypeValues } from '@/utils/enums';

import { ViewType } from '@/utils/enums';

/**
 * Iframe integrations resolve by posting the result to the parent window, so they need no
 * configured redirect URL; a full-page one has nowhere to go without it.
 */
export function canResolveVerification(url: string | undefined, viewType: ViewTypeValues | null): boolean {
  return !!url || viewType === ViewType.IFRAME;
}

export function formatSubtitle(subtitle?: string, additionalText?: string) {
  const formattedAdditionalText = additionalText ? `(${additionalText})` : undefined;

  return [subtitle, formattedAdditionalText].filter(Boolean).join(' ');
}

export function formatButtonTextWithCountdown(buttonText?: string, countdown?: number): string | undefined {
  if (!buttonText) {
    return;
  }

  if (countdown === undefined) {
    return buttonText;
  }

  return `${buttonText} ${countdown}`;
}
